<button mdbBtn mdbWavesEffect (click)="onClickButton($event)" color="blue" class="btn" type="submit" [disabled]="whenDisabled || isLoading">
    <mdb-icon *ngIf="!isLoading && iconClass.length > 0" fas icon={{iconClass}} class="mr-1"></mdb-icon>
    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span *ngIf="!isLoading">{{text}}</span>
  </button>